(ns machtfit.product-form.fileupload
  (:require [machtfit.dashboard-widgets :as widgets]
            [machtfit.materialize-widgets :refer [progress-bar progress-indicator]]
            [machtfit.utils :refer [parse-json-response]]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(rf/reg-event-db ::upload-error
  (fn [db [_ id result]]
    (let [status (-> result :jqXHR :status)
          errors (-> result :jqXHR :responseJSON :errors)]
      (-> db
          (assoc-in [:ui :upload id :errors]
                    (if (empty? errors)
                      (if (= status 413)
                        ["Die Datei ist zu groß, maximal sind 10 MiB erlaubt."]
                        ["Es ist ein Fehler beim Hochladen der Datei aufgetreten."])
                      errors))))))

(defn fileupload
  [{:keys [id input-element-id display-name param-name label accept upload-url on-success disabled?-atom]}]
  (let [csrf-token @(rf/subscribe [:get [:io :csrf-token]])
        init (fn [_element]
               (-> (js/jQuery (js/document.getElementById input-element-id))
                   (.fileupload (clj->js {:url upload-url
                                          :formData {:csrfmiddlewaretoken csrf-token}
                                          :paramName param-name
                                          :crossDomain false}))
                   (.on "fileuploadadd" (fn []
                                          (rf/dispatch [:set-path [:ui :upload (keyword id) :in-progress?] true])
                                          (rf/dispatch [:set-path [:ui :upload (keyword id) :errors] []])))
                   #_(.on "fileuploadprocessalways" #(println "processalways"))
                   (.on "fileuploadprogress" (fn [_event js-data]
                                               (let [data (js->clj js-data :keywordize-keys true)]
                                                 (rf/dispatch [:set-path [:ui :upload (keyword id) :bytes-loaded] (:loaded data)])
                                                 (rf/dispatch [:set-path [:ui :upload (keyword id) :bytes-total] (:total data)]))))
                   (.on "fileuploaddone" (fn [_event js-data]
                                           (on-success (js->clj
                                                        (parse-json-response js-data)
                                                        :keywordize-keys true))
                                           (rf/dispatch [:set-path [:ui :upload (keyword id) :in-progress?] false])))
                   (.on "fileuploadfail" (fn [_event js-data]
                                           (let [result (js->clj
                                                         js-data
                                                         :keywordize-keys true)]
                                             (rf/dispatch [::upload-error (keyword id) result])
                                             (rf/dispatch [:set-path [:ui :upload (keyword id) :in-progress?] false]))))))]
    (r/create-class
     {:component-did-mount init
      :display-name display-name
      :reagent-render (fn []
                        (let [status @(rf/subscribe [:get [:ui :upload id]])
                              {:keys [errors
                                      in-progress?
                                      bytes-loaded
                                      bytes-total]} status
                              disabled? (and (some? disabled?-atom) @disabled?-atom)]
                          [:div
                           [:div.waves-effect.waves-light.btn
                            {:style {:margin-bottom "2rem"} :class (when (or disabled? in-progress?) "disabled")}
                            [:input.file-upload
                             {:id input-element-id
                              :type "file"
                              :accept (if (some? accept) accept "*/*")}]
                            (if in-progress?
                              [progress-indicator]
                              [:i.material-icons.left "file_upload"])
                            [:span label]]
                           (when (and in-progress? (some? bytes-loaded))
                             [progress-bar bytes-loaded bytes-total])

                           [widgets/error-messages errors]]))})))

(defn reset-error [current-db id]
  (assoc-in current-db [:ui :upload (keyword id) :errors] []))
